import {
  GET_ALL_ARMS_MANAGE,
  ADD_ARMS_MANAGMENT,
  UPDATE_ARMS_MANAGMENT,
  GET_ARMS_BY_ID,
} from '../types'

const INITIAL_STATE = {
  getAllArms: [],
  addArmsMang: [],
  updateArms: [],
  getOneArms: [],
  page_count: null,
}

const armsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_ARMS_MANAGE:
      return {
        ...state,
        getAllArms: payload.data,
        page_count: payload.total_records,
      }

    case ADD_ARMS_MANAGMENT:
      return {
        ...state,
        addArmsMang: payload.data,
        loader: false,
      }

    case UPDATE_ARMS_MANAGMENT:
      return {
        ...state,
        updateArms: payload.data,
      }
    case GET_ARMS_BY_ID:
      return {
        ...state,
        getOneArms: payload.data,
      }
    default:
      return state
  }
}

export default armsReducer
